module.exports = __webpack_public_path__ + "img/NormalQuestion.38854cba.svg";